import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

class SyncData extends Component {

    componentDidMount() {
        const document_store = this.props.document_store;
        document_store.timeout_to_sync = setTimeout(this.fetchDocuments.bind(this), document_store.time_to_sync);
    }

    componentWillUnmount() {
        const document_store = this.props.document_store;
        clearTimeout(document_store.timeout_to_sync);
    }

    fetchDocuments() {
        const document_store = this.props.document_store;

        if (document_store.timeout_to_sync) {
            // console.info('canceling previous sync...');
            clearTimeout(document_store.timeout_to_sync);
        }

        const active_status = this.props.status || document_store.active_section;

        if (active_status !== 'done' && !document_store.fetching) {
            // console.info('syncing...', active_status);
            document_store.fetch({ filter: { status: active_status } }, true);
        }

        document_store.timeout_to_sync = setTimeout(this.fetchDocuments.bind(this), document_store.time_to_sync);
    }

    render() {
        const document_store = this.props.document_store || {};
        return (<span style={{display: 'none'}}>{document_store.updated_at.toString()}</span>);
    }
}

let container = observer(SyncData);
container = inject(['document_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/components/SyncData.js